export default __webpack_public_path__ + "static/media/IMG_1000.jpeg.20cf9a66.jpg";